import { FlexResponsive, LabeledData } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { StyledDivider } from 'baseui/divider';
import { useBreakpoints } from '../../../hooks/useBreakpoints';
import { useStyles } from '../../../hooks/useStyles';
import { CurrentState } from '../../../types/asset';
import LabeledDataCard from '../labeledDataCard/LabeledDataCard';

type Props = Readonly<{
  currentState?: CurrentState;
}>;

function CurrentStateLocation({ currentState }: Props) {
  const { theme, overrides } = useStyles();
  const { isXSmall } = useBreakpoints();

  return (
    <LabeledDataCard
      label="Ubicación"
      rootStyleOverrides={{
        flexGrow: 2,
        flexShrink: 1,
        flexBasis: 0,
      }}
    >
      <FlexResponsive
        gap={isXSmall ? 0 : theme.sizing.scale800}
        breakAt="medium"
      >
        <Block>
          <LabeledData
            label="Latitud:"
            content={(currentState?.position_latitude || '-').toString()}
            labelWidth="50px"
            inline={false}
            maxLines={3}
          />
        </Block>
        {isXSmall && <StyledDivider style={overrides.dividerStyleOverrides} />}
        <Block>
          <LabeledData
            label="Longitud:"
            content={(currentState?.position_longitude || '-').toString()}
            labelWidth="50px"
            inline={false}
            maxLines={3}
          />
        </Block>
      </FlexResponsive>
      <StyledDivider style={overrides.dividerStyleOverrides} />
      <LabeledData
        label="Georeferencia:"
        labelWidth="100px"
        content={currentState?.geoReference || '-'}
        inline={false}
        maxLines={5}
      />
    </LabeledDataCard>
  );
}

export default CurrentStateLocation;
